<template>
  <AisRefinementList
    :attribute="filterAttribute"
    :show-more="numberOfCategoriesToShow > 0"
    :show-more-limit="maximumNumberOfFacetValuesToDisplay"
    :limit="numberOfCategoriesToShow"
  >
    <template
      #default="{
        items,
        refine,
        toggleShowMore,
        canToggleShowMore,
        isShowingMore,
      }"
    >
      <div v-if="!items.length" class="empty hidden"></div>
      <div
        v-auto-animate
        class="mb-2 grid grid-cols-3 gap-4 lg:gap-2 2xl:gap-4"
      >
        <SingleCategory
          v-for="item of items"
          :key="item.value"
          :item="item"
          :category="getCategory(item.value)"
          @category-click="() => refine(item.value)"
        />
      </div>
      <ShowMoreLessFacets
        :can-toggle-show-more="canToggleShowMore"
        :is-showing-more="isShowingMore"
        class="mt-2"
        @show-more-less-toggled="toggleShowMore"
      />
    </template>
  </AisRefinementList>
</template>

<script setup lang="ts">
import { useAlgoliaCategoryStore } from '@/stores/Category/AlgoliaCategoryStore.ts';
import { onMounted, ref } from 'vue';
import { AlgoliaCategory } from '@/types/Algolia/AlgoliaCategory';
import SingleCategory from '@/pages/CategoryPage/Partials/Filters/SingleCategory.vue';
import ShowMoreLessFacets from '@/pages/CategoryPage/Partials/Filters/ShowMoreLessFacets.vue';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

export type CheckboxFilterProps = {
  filterAttribute: string;
};
defineProps<CheckboxFilterProps>();

const {
  getCategories,
  numberOfCategoriesToDisplayOnDesktop,
  numberOfCategoriesToDisplayOnMobile,
  maximumNumberOfFacetValuesToDisplay,
} = useAlgoliaCategoryStore();
const breakpoints = useBreakpoints(breakpointsTailwind);

const categories = ref<AlgoliaCategory[]>([]);
const numberOfCategoriesToShow = ref(numberOfCategoriesToDisplayOnDesktop);

function getCategory(value: string) {
  return categories.value.find(c => c.name === value);
}

onMounted(async () => {
  categories.value = await getCategories();
  numberOfCategoriesToShow.value = breakpoints.greaterOrEqual('lg').value
    ? numberOfCategoriesToDisplayOnDesktop
    : numberOfCategoriesToDisplayOnMobile;
});
</script>
